import React, { useState } from "react";

const EyeOpen = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12S5 4 12 4s11 8 11 8-4 8-11 8S1 12 1 12Z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EyeOff = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20C5 20 1 12 1 12a18.5 18.5 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
    <path d="M14.12 14.12A3 3 0 1 1 9.88 9.88M1 1l22 22" />
  </svg>
);

/** Kaba bir dayanıklılık ölçüsü — sunucu kuralı değil, kullanıcıya yol gösterir. */
export const scorePassword = (v: string): { score: 0 | 1 | 2 | 3; label: string } => {
  if (!v) return { score: 0, label: "" };
  let s = 0;
  if (v.length >= 8) s++;
  if (v.length >= 12) s++;
  if (/[a-z]/.test(v) && /[A-Z]/.test(v)) s++;
  if (/\d/.test(v)) s++;
  if (/[^A-Za-z0-9]/.test(v)) s++;
  if (v.length < 6) return { score: 0, label: "Çok kısa" };
  if (s <= 2) return { score: 1, label: "Zayıf" };
  if (s <= 3) return { score: 2, label: "Orta" };
  return { score: 3, label: "Güçlü" };
};

interface Props {
  id: string;
  label: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  autoComplete?: string;
  autoFocus?: boolean;
  /** Dayanıklılık göstergesi (yalnız yeni şifre alanlarında anlamlı) */
  strength?: boolean;
  hint?: string;
}

/** Göster/gizle düğmeli şifre alanı; Login'in lg-* görsel diliyle. */
const PasswordField: React.FC<Props> = ({
  id, label, value, onChange, placeholder = "••••••••",
  autoComplete = "new-password", autoFocus, strength, hint,
}) => {
  const [show, setShow] = useState(false);
  const s = strength ? scorePassword(value) : null;

  return (
    <div className="lg-field">
      <label htmlFor={id}>{label}</label>
      <div className="lg-pass-wrap">
        <input
          id={id}
          type={show ? "text" : "password"}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          required
        />
        <button
          type="button"
          className="lg-pass-toggle"
          onClick={() => setShow((v) => !v)}
          aria-label={show ? "Şifreyi gizle" : "Şifreyi göster"}
          tabIndex={-1}
        >
          {show ? <EyeOff /> : <EyeOpen />}
        </button>
      </div>

      {s && value && (
        <div className={`lg-strength s${s.score}`}>
          <span className="lg-strength-bars" aria-hidden="true">
            <i /><i /><i />
          </span>
          <span className="lg-strength-label">{s.label}</span>
        </div>
      )}
      {hint && !(s && value) && <small className="lg-hint">{hint}</small>}
    </div>
  );
};

export default PasswordField;
